const Here = window.H;

let plotsGroup

const PlotsPlugin = () => {

    const mutatePlots = {
        update(plotObj) {
            plotsGroup.removeObjects([plotObj.plot, plotObj.verticeGroup]);
            plotsGroup.addObjects([plotObj.plot, plotObj.verticeGroup]);
        },

        remove(plotObj) {
            plotsGroup.removeObjects([plotObj.plot, plotObj.verticeGroup]);
        }
    }

    const initPlugin = ({ onPlotClick, onPlotCreated, onPlotChange, onPlotRemoved, initialData = [], setCenter }) => (map) => {
        const svgCircle = '<svg width="20" height="20" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
            '<circle cx="10" cy="10" r="7" fill="transparent" stroke="red" stroke-width="4"/>' +
            '</svg>'

        const _createFormInitialData = (initialData = []) => {

            initialData.forEach((data) => {
                const segments = data.coord.reduce((acc, c) => ([c.lat, c.lng, 0, ...acc]), [])

                const [plot, verticeGroup] = _createPlot(segments);

                plot.setData(data.originalData);

                // create plots group if not there with first plot
                if (!plotsGroup) {
                    _createPlotsGroup(plot, verticeGroup);
                } else {
                    plotsGroup.addObjects([plot, verticeGroup]);
                }
            })
        }

        const _startListener = (cb) => {
            const handleEvent = (evt) => {
                const coord = map.screenToGeo(evt.currentPointer.viewportX,
                    evt.currentPointer.viewportY);

                const { lat, lng } = coord;
                setCenter({lat,lng})

                return cb(null, { lat, lng });
            }

            map.addEventListener('tap', handleEvent);

            return {
                unsubscribe: () => map.removeEventListener('tap', handleEvent)
            }
        }

        const _createPlotsGroup = (plot, verticeGroup) => {
            plotsGroup = new Here.map.Group({
                volatility: true, // mark the group as volatile for smooth dragging of all it's objects
                objects: [plot, verticeGroup]
            })

            map.addObject(plotsGroup)
            return
        }

        const _createPlotConfiguration = (plot, verticeGroup) => {
            let plotConfiguration = []
            plot.getGeometry().getExterior().eachLatLngAlt((lat, lng, alt, index) => {
                plotConfiguration.push({ lat, lng, index })
            })

            return {
                coord: JSON.stringify(plotConfiguration),
                mapObj: { plot, verticeGroup },
                originalData: plot.getData()
            }
        }

        const _createPlot = (plotSegments) => {
            const plot = new Here.map.Polygon(
                new Here.geo.Polygon(new Here.geo.LineString(plotSegments)),
                {
                    style: { fillColor: "rgba(171,36,48, 0.4)", lineWidth: 0 }
                }
            );

            plot.draggable = true;

            const verticeGroup = new Here.map.Group({
                visibility: false,
                zIndex: 10
            })

            plot.getGeometry().getExterior().eachLatLngAlt((lat, lng, alt, index) => {
                const vertice = new Here.map.Marker(
                    { lat, lng },
                    {
                        icon: new Here.map.Icon(svgCircle, { anchor: { x: 10, y: 10 } })
                    }
                );
                vertice.draggable = true;
                vertice.setData({ 'verticeIndex': index })
                verticeGroup.addObject(vertice);
            });

            // event listener for vertice markers group to change the cursor to pointer
            verticeGroup.addEventListener('pointerenter', (evt) => {
                document.body.style.cursor = 'pointer';
                verticeGroup.setVisibility(true);
            }, true);

            // event listener for vertice markers group to change the cursor to default
            verticeGroup.addEventListener('pointerleave', (evt) => {
                document.body.style.cursor = 'default';
                verticeGroup.setVisibility(false);
            }, true);

            // event listener for vertice markers group to change the cursor to pointer
            plot.addEventListener('pointerenter', (evt) => {
                verticeGroup.setVisibility(true);
            }, true);

            // event listener for vertice markers group to change the cursor to default
            plot.addEventListener('pointerleave', (evt) => {
                verticeGroup.setVisibility(false);
            }, true);

            plot.addEventListener('tap', (evt) => {
                // Delete when clicking with left mouse
                const plotConfiguration = _createPlotConfiguration(plot, verticeGroup);

                if (evt.originalEvent.which === 3) {
                    if (window.confirm("Rimuovere questo appezzamento?")) {
                        plotsGroup.removeObjects([plot, verticeGroup]);
                        onPlotRemoved(plotConfiguration);
                    }
                } else {
                    onPlotClick(plotConfiguration);
                }

                evt.stopPropagation();
            })

            verticeGroup.addEventListener('drag', (evt) => {
                const pointer = evt.currentPointer,
                    geoLineString = plot.getGeometry().getExterior(),
                    geoPoint = map.screenToGeo(pointer.viewportX, pointer.viewportY);

                // set new position for vertice marker
                evt.target.setGeometry(geoPoint);

                // set new position for plot's vertice
                geoLineString.removePoint(evt.target.getData()['verticeIndex']);
                geoLineString.insertPoint(evt.target.getData()['verticeIndex'], geoPoint);
                plot.setGeometry(new Here.geo.Polygon(geoLineString));

                // stop propagating the drag event, so the map doesn't move
                evt.stopPropagation();
            }, true);

            verticeGroup.addEventListener('dragend', evt => {
                const plotConfiguration = _createPlotConfiguration(plot, verticeGroup);
                onPlotChange(plotConfiguration);

                evt.stopPropagation()
            })

            return [plot, verticeGroup]
        }

        // When the user clicks on a free map space, a new plot is created
        _startListener((error, { lat, lng }) => {
            const segment1 = [lat - 0.0005, lng - 0.0005, 0];
            const segment2 = [lat - 0.0005, lng + 0.0005, 0];
            const segment3 = [lat + 0.0005, lng + 0.0005, 0];
            const segment4 = [lat + 0.0005, lng - 0.0005, 0];

            const segments = [...segment1, ...segment2, ...segment3, ...segment4];

            const [plot, verticeGroup] = _createPlot(segments);

            const plotConfiguration = _createPlotConfiguration(plot, verticeGroup);
            onPlotCreated(plotConfiguration);

            // create plots group if not there with first plot
            if (!plotsGroup) {
                _createPlotsGroup(plot, verticeGroup);
            } else {
                plotsGroup.addObjects([plot, verticeGroup]);
            }
        });

        if (initialData.length > 0) {
            plotsGroup = null
            _createFormInitialData(initialData)
        }
    }

    return {initPlugin, mutatePlots}
};

export default PlotsPlugin
